/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  (function () {
    var NOTE_TEXT = 'I want to waive the delivery signature of my order.';
    var STORAGE_KEYS = ['waive_signature', 'wave_signature'];

    function getPref() {
      for (var i = 0; i < STORAGE_KEYS.length; i++) {
        var key = STORAGE_KEYS[i];
        try {
          var value = localStorage.getItem(key);
          if (value === 'yes' || value === 'no') return value === 'yes';
        } catch (e) {}
      }
      return false;
    }

    function setPref(enabled) {
      var value = enabled ? 'yes' : 'no';
      STORAGE_KEYS.forEach(function (key) {
        try {
          localStorage.setItem(key, value);
        } catch (e) {}
      });
    }

    function updateCart(enabled) {
      var attrValue = enabled ? 'yes' : '';
      var note = enabled ? NOTE_TEXT : '';
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          note: note,
          attributes: {
            waive_signature: attrValue,
            wave_signature: attrValue
          }
        })
      });
    }

    function syncUI() {
      var enabled = getPref();
      document.querySelectorAll('#WaiveSignatureCheckbox').forEach(function (el) {
        el.checked = enabled;
      });
      document.querySelectorAll('#WaiveSignatureAttr, #WaveSignatureAttr').forEach(function (el) {
        el.value = enabled ? 'yes' : '';
      });
    }

    function bind() {
      document.addEventListener('change', function (e) {
        if (e.target && e.target.id === 'WaiveSignatureCheckbox') {
          var enabled = !!e.target.checked;
          setPref(enabled);
          updateCart(enabled).then(function () {
            syncUI();
            // Optional: trigger Palo Alto cart refresh event if needed
            // document.dispatchEvent(new CustomEvent('cart:refresh'));
          });
        }
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      bind();
      syncUI();
    });

    // For OS 2.0 section re-renders / drawer refreshes
    document.addEventListener('shopify:section:load', syncUI);
  })();

  (function () {
    function getCustomerTags() {
      var tags = window.theme && Array.isArray(window.theme.customerTags) ? window.theme.customerTags : [];
      return tags.map(function (tag) { return String(tag || '').toLowerCase().trim(); }).filter(Boolean);
    }

    function hasTag(tags, tagName) {
      return tags.indexOf(tagName) !== -1;
    }

    function getApprovedPro(tags) {
      return hasTag(tags, 'wholesale') || hasTag(tags, 'verified') || hasTag(tags, 'vip');
    }

    function getProModifier(tags) {
      var modifier = 1;

      if (hasTag(tags, 'wholesale')) {
        modifier = 0.6667;
      } else if (hasTag(tags, 'verified')) {
        modifier = 0.5;
      }

      if (hasTag(tags, 'vip')) {
        modifier = modifier * 0.6;
      }

      return modifier;
    }

    function formatMoney(cents) {
      if (window.theme && typeof window.theme.formatMoney === 'function') {
        return window.theme.formatMoney(cents, window.theme.moneyWithCurrencyFormat);
      }
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, (window.theme && window.theme.moneyWithCurrencyFormat) || '${{amount}}');
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function applyProTotals() {
      var tags = getCustomerTags();
      if (!getApprovedPro(tags)) return;

      var modifier = getProModifier(tags);
      var subtotalSource = document.querySelector('[data-cart-total]');
      if (!subtotalSource) return;

      var baseSubtotal = parseInt(subtotalSource.getAttribute('data-cart-total'), 10);
      if (isNaN(baseSubtotal)) return;

      var adjustedSubtotal = Math.round(baseSubtotal * modifier);
      var formattedAdjustedSubtotal = adjustedSubtotal === 0 ? ((window.theme && window.theme.strings && window.theme.strings.free) || 'Free') : formatMoney(adjustedSubtotal);

      document.querySelectorAll('[data-cart-total-price]').forEach(function (el) {
        el.innerHTML = formattedAdjustedSubtotal;
      });
    }

    function hideApprovedAccountPendingMessage() {
      if (!window.location.pathname || window.location.pathname.indexOf('/account') !== 0) return;

      var tags = getCustomerTags();
      if (!getApprovedPro(tags)) return;

      document.querySelectorAll('[data-pending-verification], .pending-verification').forEach(function (el) {
        el.style.display = 'none';
      });

      document.querySelectorAll('p, div, span, li').forEach(function (el) {
        var txt = (el.textContent || '').toLowerCase();
        if (txt.indexOf('pending verification') !== -1) {
          el.style.display = 'none';
        }
      });
    }

    function runProAccessUiRules() {
      applyProTotals();
      hideApprovedAccountPendingMessage();
    }

    document.addEventListener('DOMContentLoaded', runProAccessUiRules);
    document.addEventListener('shopify:section:load', runProAccessUiRules);
    document.addEventListener('theme:cart:change', runProAccessUiRules);
    document.addEventListener('cart:updated', runProAccessUiRules);
  })();






  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
